export const AuthControllerRoute = {
    login: "/api/Auth/login",
    register: "/api/Auth/registro",
    validateToken: "/api/Auth/validar-token",
    me: "/api/Auth/me",
    changePassword: "/api/Auth/alterar-senha",
}